import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["activity", "label"]

  connect() {
    // Set initial state
    this.currentFilter = "all"
  }

  filterBy(event) {
    event.preventDefault()
    
    const type = event.currentTarget.dataset.type
    const label = event.currentTarget.textContent
    
    // Update button label
    this.labelTarget.textContent = label
    
    // Update active state in dropdown
    this.element.querySelectorAll('a').forEach(link => {
      link.classList.remove('active')
    })
    event.currentTarget.classList.add('active')
    
    // Filter activities
    this.activityTargets.forEach(activity => {
      const activityType = activity.dataset.activityType
      
      if (type === "all" || activityType === type) {
        activity.style.display = ""
      } else {
        activity.style.display = "none"
      }
    })
    
    // Close dropdown (DaisyUI behavior)
    this.element.querySelector('[tabindex="0"]').blur()
    
    this.currentFilter = type
  }
} 